webpackJsonp([17,0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(5);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _domready = __webpack_require__(31);
	
	var _domready2 = _interopRequireDefault(_domready);
	
	var _HeroCarousel = __webpack_require__(1034);
	
	var _HeroCarousel2 = _interopRequireDefault(_HeroCarousel);
	
	var _index = __webpack_require__(473);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _TextAppForm = __webpack_require__(1170);
	
	var _TextAppForm2 = _interopRequireDefault(_TextAppForm);
	
	var _YoutubePlayer = __webpack_require__(170);
	
	var _YoutubePlayer2 = _interopRequireDefault(_YoutubePlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Leave commented out for easy static markup creation
	// import { renderToStaticMarkup } from 'react-dom/server';
	// import BrandsSearchBar from './components/BrandsSearchBar/BrandsSearchBar';
	// import TextAppForm from 'shared-components/TextAppForm/component';
	
	var slides = window.Raise.data.homepage.carousel;
	var _window$Raise$data$ho = window.Raise.data.homepage.guarantee;
	var placeholder = _window$Raise$data$ho.placeholder;
	var headline = _window$Raise$data$ho.headline;
	var videoId = _window$Raise$data$ho.videoId;
	
	
	(0, _domready2.default)(function () {
	  var $carouselEl = document.getElementById('react-hero-carousel');
	  var carousel = _react2.default.createElement(_HeroCarousel2.default, { slides: slides });
	  var $searchBarEl = document.getElementById('react-search-bar');
	  var $textAppFormEl = document.getElementById('text-app-form');
	  var $guaranteeVideoEl = document.getElementById('guarantee-video-container');
	  var video = _react2.default.createElement(_YoutubePlayer2.default, { videoId: videoId, placeholder: placeholder, headline: headline });
	
	  if ($carouselEl) _reactDom2.default.render(carousel, $carouselEl);
	  if ($searchBarEl) _index2.default.standalone($searchBarEl);
	  if ($textAppFormEl) _TextAppForm2.default.standalone($textAppFormEl);
	  if ($guaranteeVideoEl) _reactDom2.default.render(video, $guaranteeVideoEl);
	
	  // Leave commented out for easy static markup creation
	  // console.warn('HeroCarousel');
	  // slides.forEach((slide) => slide.url = 'https://dnrzlv4wd9rbi.cloudfront.net/assets/new_homepage/buyGiftCards.jpg');
	  // console.log(renderToStaticMarkup(carousel));
	  // console.warn('BrandsSearchBar');
	  // console.log(brandsSearchBar.renderStaticMarkup());
	  // console.warn('TextAppForm');
	  // console.log(textAppForm.renderStaticMarkup());
	  // console.warn('Video');
	  // console.log(renderToStaticMarkup(video));
	  //
	});

/***/ },

/***/ 29:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reduxAct = __webpack_require__(26);
	
	exports.default = function (namespace, actions) {
	  return actions.reduce(function (result, action) {
	    result[action] = (0, _reduxAct.createAction)(namespace + ':' + action); // eslint-disable-line
	    return result;
	  }, {});
	};

/***/ },

/***/ 43:
6,

/***/ 166:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var players = {};
	var ready = false;
	
	var isYouTubeApiMounted = exports.isYouTubeApiMounted = function isYouTubeApiMounted() {
	  return _typeof(window.YT) === 'object' && window.YT.Player;
	};
	
	var isYouTubeApiReady = exports.isYouTubeApiReady = function isYouTubeApiReady() {
	  return ready;
	};
	
	var getPlayer = function getPlayer(iframeId, events) {
	  return new window.YT.Player(iframeId, {
	    iframeId: iframeId,
	    events: events
	  });
	};
	
	window.onYouTubeIframeAPIReady = function () {
	  ready = true;
	  var videoId = void 0;
	
	  if (!Object.keys(players).length) return;
	  for (videoId in players) {
	    if (players.hasOwnProperty(videoId)) {
	      var playerOpts = players[videoId];
	      playerOpts.onApiReady(getPlayer(playerOpts.id, playerOpts.events));
	      delete players[videoId];
	    }
	  }
	};
	
	var initPlayer = exports.initPlayer = function initPlayer(videoId, options) {
	  if (isYouTubeApiMounted() && isYouTubeApiReady()) {
	    options.onApiReady(getPlayer(options.id, options.events));
	  } else if (isYouTubeApiMounted() && !isYouTubeApiReady()) {
	    players[videoId] = options;
	    window.onYouTubeIframeAPIReady();
	  }
	  players[videoId] = options;
	};
	
	exports.default = {
	  initPlayer: initPlayer,
	  isYouTubeApiReady: isYouTubeApiReady,
	  isYouTubeApiMounted: isYouTubeApiMounted
	};

/***/ },

/***/ 170:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _index = __webpack_require__(175);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _youtube = __webpack_require__(166);
	
	var _youtube2 = _interopRequireDefault(_youtube);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var randomValue = function randomValue() {
	  return new Date().getTime() + Math.floor(Math.random() * 9999) + 100;
	};
	
	var playButtonSVG = _react2.default.createElement(
	  'svg',
	  { version: '1.1', xmlns: 'http://www.w3.org/2000/svg', width: '50px', x: '0px', y: '0px', viewBox: '0 0 50 50' },
	  _react2.default.createElement(
	    'g',
	    null,
	    _react2.default.createElement('path', { id: 'Fill-5', fill: '#F4F4F4', d: 'M49.7,24.7c0,13.5-11,24.5-24.5,24.5S0.7,38.3,0.7,24.7s11-24.5,24.5-24.5 S49.7,11.2,49.7,24.7' }),
	    _react2.default.createElement('path', { id: 'Fill-7', fill: '#3F484D', d: 'M18.9,34.2c-0.1,0-0.2,0-0.3-0.1c-0.2-0.1-0.3-0.3-0.3-0.5V15.9c0-0.2,0.1-0.4,0.3-0.5 c0.2-0.1,0.4-0.1,0.6,0l16.5,8.9c0.2,0.1,0.3,0.3,0.3,0.5c0,0.2-0.1,0.4-0.3,0.5l-16.5,8.9C19.1,34.1,19,34.2,18.9,34.2' })
	  )
	);
	
	var YoutubePlayer = function (_Component) {
	  _inherits(YoutubePlayer, _Component);
	
	  function YoutubePlayer() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, YoutubePlayer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(YoutubePlayer)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      player: null,
	      embedReady: false,
	      placeholderHidden: false
	    }, _this.onStateChange = function (e) {
	      var videoEnded = e.data === 0;
	      if (videoEnded) {
	        _this.setState({
	          placeholderHidden: false
	        });
	        if (_this.props.autoplay) _this.props.onVideoEnd();
	      }
	    }, _this.onReady = function () {
	      _this.setState({
	        embedReady: true
	      });
	      if (_this.props.autoplay) _this.state.player.playVideo();
	    }, _this.onApiReady = function (player) {
	      _this.setState({
	        player: player
	      });
	    }, _this.clickPlaceholder = function () {
	      if (_this.state.player && _this.state.player.playVideo) {
	        _this.state.player.playVideo();
	        _this.setState({
	          placeholderHidden: true
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(YoutubePlayer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.id = 'YTP-' + randomValue();
	      if (this.props.autoplay) this.setState({ placeholderHidden: true });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var options = {
	        id: this.id,
	        onApiReady: this.onApiReady,
	        events: {
	          onReady: this.onReady,
	          onStateChange: this.onStateChange
	        }
	      };
	      _youtube2.default.initPlayer(this.props.videoId, options);
	    }
	  }, {
	    key: 'getWrapperStyles',
	    value: function getWrapperStyles() {
	      var _props = this.props;
	      var width = _props.width;
	      var height = _props.height;
	
	      var wrapperStyles = {};
	
	      if (width) wrapperStyles.width = width + 'px';
	      if (height) wrapperStyles.height = height + 'px';
	      return wrapperStyles;
	    }
	  }, {
	    key: 'embedSrc',
	    value: function embedSrc() {
	      return 'https://www.youtube.com/embed/' + this.props.videoId + '?enablejsapi=1';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _cx;
	
	      var placeholderClasses = (0, _classnames2.default)((_cx = {}, _defineProperty(_cx, _index2.default.placeholder, true), _defineProperty(_cx, _index2.default.hide, this.state.placeholderHidden), _cx));
	
	      var wrapperAttributes = {
	        className: _index2.default.youtubeWrapper,
	        style: this.getWrapperStyles()
	      };
	
	      var iframeClasses = (0, _classnames2.default)(_defineProperty({}, _index2.default.hide, !this.state.placeholderHidden));
	
	      var iframeAttributes = {
	        className: iframeClasses,
	        id: this.id,
	        width: '100%',
	        height: '100%',
	        src: this.embedSrc(),
	        frameBorder: 0,
	        allowFullScreen: true
	      };
	
	      var placeholderStyles = {
	        backgroundImage: 'url(' + this.props.placeholder + ')'
	      };
	
	      var placeholderAttributes = {
	        className: placeholderClasses,
	        style: placeholderStyles,
	        onClick: this.clickPlaceholder
	      };
	
	      var headline = this.props.headline || '';
	
	      return _react2.default.createElement(
	        'div',
	        wrapperAttributes,
	        _react2.default.createElement('iframe', iframeAttributes),
	        _react2.default.createElement(
	          'div',
	          placeholderAttributes,
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.placeholderContents },
	            _react2.default.createElement(
	              'h2',
	              { className: _index2.default.headline },
	              headline
	            ),
	            playButtonSVG
	          )
	        )
	      );
	    }
	  }]);
	
	  return YoutubePlayer;
	}(_react.Component);
	
	YoutubePlayer.propTypes = {
	  videoId: _react.PropTypes.string.isRequired,
	  width: _react.PropTypes.string,
	  height: _react.PropTypes.string,
	  placeholder: _react.PropTypes.string,
	  headline: _react.PropTypes.string,
	  autoplay: _react.PropTypes.bool,
	  onVideoEnd: _react.PropTypes.func
	};
	
	exports.default = YoutubePlayer;

/***/ },

/***/ 175:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"youtubeWrapper":"youtubeWrapper--1V4fH","placeholder":"placeholder--1VWFA","placeholderContents":"placeholderContents--3b_rz","headline":"headline--i4mwU","hide":"hide--28yEk"};

/***/ },

/***/ 176:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"baseButton":"baseButton--kqR6C","mintGreen":"mintGreen--N1BlE","marigold":"marigold--1Kt6A","raiseBlue":"raiseBlue--2rOSi","active":"active--aIB8B","clearWhite":"clearWhite--1TyVY"};

/***/ },

/***/ 219:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.reducer = exports.Actions = exports.initialState = undefined;
	
	var _createReducer;
	
	var _reduxAct = __webpack_require__(26);
	
	var _immutable = __webpack_require__(16);
	
	var _createActions = __webpack_require__(29);
	
	var _createActions2 = _interopRequireDefault(_createActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = exports.initialState = (0, _immutable.fromJS)({
	  allItems: [],
	  selectedItemIndex: null,
	  lastKeyboardSelectedItemIndex: null,
	  direction: null
	});
	
	var Actions = exports.Actions = (0, _createActions2.default)('SearchBar', ['resetSelections', 'storeAllItems', 'selectItemByDirection', 'selectItemByIndex']);
	
	var selectItemByDirection = function selectItemByDirection(state, _ref) {
	  var direction = _ref.direction;
	  var numItems = _ref.filteredLength;
	
	  var currentItem = state.get('selectedItemIndex');
	  var selectedItem = void 0;
	  if (direction === 1) {
	    if (currentItem === numItems - 1) {
	      selectedItem = null;
	    } else {
	      if (currentItem === null) {
	        selectedItem = 0;
	      } else {
	        selectedItem = currentItem + 1;
	      }
	    }
	  } else {
	    if (direction === -1) {
	      if (currentItem === 0) {
	        selectedItem = null;
	      } else {
	        if (currentItem === null) {
	          selectedItem = numItems - 1;
	        } else {
	          selectedItem = currentItem - 1;
	        }
	      }
	    }
	  }
	  return selectedItem;
	};
	
	var reducer = exports.reducer = (0, _reduxAct.createReducer)((_createReducer = {}, _defineProperty(_createReducer, Actions.resetSelections, function (state) {
	  return state.set('selectedItemIndex', null).set('lastKeyboardSelectedItemIndex', null);
	}), _defineProperty(_createReducer, Actions.storeAllItems, function (state, allItems) {
	  return state.set('allItems', allItems);
	}), _defineProperty(_createReducer, Actions.selectItemByDirection, function (state, payload) {
	  var index = selectItemByDirection(state, payload);
	  return state.set('direction', payload.direction).set('selectedItemIndex', index).set('lastKeyboardSelectedItemIndex', index);
	}), _defineProperty(_createReducer, Actions.selectItemByIndex, function (state, index) {
	  return state.set('direction', 0).set('selectedItemIndex', index);
	}), _createReducer), initialState);

/***/ },

/***/ 288:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(5);
	
	module.exports = function enhanceWithClickOutside(WrappedComponent) {
	  var componentName = WrappedComponent.displayName || WrappedComponent.name;
	
	  return React.createClass({
	    displayName: 'Wrapped' + componentName,
	
	    componentDidMount: function componentDidMount() {
	      this.__wrappedComponent = this.refs.wrappedComponent;
	      document.addEventListener('click', this.handleClickOutside, true);
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	      document.removeEventListener('click', this.handleClickOutside, true);
	    },
	
	    handleClickOutside: function handleClickOutside(e) {
	      var domNode = ReactDOM.findDOMNode(this);
	      if ((!domNode || !domNode.contains(e.target)) && typeof this.refs.wrappedComponent.handleClickOutside === 'function') {
	        this.refs.wrappedComponent.handleClickOutside(e);
	      }
	    },
	
	    render: function render() {
	      return React.createElement(WrappedComponent, _extends({}, this.props, { ref: 'wrappedComponent' }));
	    }
	  });
	};

/***/ },

/***/ 316:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _component = __webpack_require__(612);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _reducer = __webpack_require__(219);
	
	var _Dropdown = __webpack_require__(555);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _MagnifyingGlassIcon = __webpack_require__(557);
	
	var _MagnifyingGlassIcon2 = _interopRequireDefault(_MagnifyingGlassIcon);
	
	var _reactClickOutside = __webpack_require__(288);
	
	var _reactClickOutside2 = _interopRequireDefault(_reactClickOutside);
	
	var _filteredSelector = __webpack_require__(558);
	
	var _filteredSelector2 = _interopRequireDefault(_filteredSelector);
	
	var _classNames = __webpack_require__(43);
	
	var _classNames2 = _interopRequireDefault(_classNames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SearchBar = function (_Component) {
	  _inherits(SearchBar, _Component);
	
	  function SearchBar() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SearchBar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(SearchBar)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      inputValue: '',
	      open: false,
	      submit: false
	    }, _this.handleKeyDown = function (e) {
	      var dispatch = _this.props.dispatch;
	
	      var inputValue = e.target.value;
	      var keyCode = e.which || e.keyCode;
	      var filteredLength = _this.filteredItems().length;
	      if (!keyCode) return;
	      switch (keyCode) {
	        case 40:
	          // arrow down
	          dispatch(_reducer.Actions.selectItemByDirection({ direction: 1, filteredLength: filteredLength }));
	          e.preventDefault();
	          break;
	        case 38:
	          // arrow up
	          dispatch(_reducer.Actions.selectItemByDirection({ direction: -1, filteredLength: filteredLength }));
	          e.preventDefault();
	          break;
	        case 39:
	          // arrow right
	          _this.setStateAndReset(inputValue);
	          break;
	        case 37:
	          // arrow left
	          _this.setStateAndReset(inputValue);
	          break;
	        case 13:
	          _this.handleKeyEnter(e);
	          break;
	        case 27:
	          // esc
	          _this.handleClickOutside();
	          break;
	        default:
	          break;
	      }
	    }, _this.handleChange = function (e) {
	      _this.setStateAndReset(e.target.value);
	    }, _this.handleKeyEnter = function (e) {
	      _this.props.onKeyEnter(e);
	    }, _this.handleClickItem = function (inputValue, item) {
	      _this.setState({ inputValue: inputValue, submit: true, open: false }, function () {
	        _this.props.onBrandSelect(item);
	      });
	    }, _this.handleClickInput = function () {
	      if (!_this.state.open) _this.setState({ open: true });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SearchBar, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      if (newProps.items.length !== this.props.items.length) {
	        this.props.dispatch(_reducer.Actions.storeAllItems(newProps.items));
	        this.resetSelections();
	      }
	    }
	  }, {
	    key: 'setStateAndReset',
	    value: function setStateAndReset(inputValue) {
	      this.setState({ inputValue: inputValue, open: true });
	      this.resetSelections();
	    }
	  }, {
	    key: 'resetSelections',
	    value: function resetSelections() {
	      this.props.dispatch(_reducer.Actions.resetSelections());
	    }
	  }, {
	    key: 'handleClickOutside',
	    value: function handleClickOutside() {
	      this.setState({ open: false });
	    }
	  }, {
	    key: 'filteredItems',
	    value: function filteredItems() {
	      return (0, _filteredSelector2.default)([this.state, this.props]);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _cx;
	
	      var _state = this.state;
	      var submit = _state.submit;
	      var inputValue = _state.inputValue;
	      var _props$model = this.props.model;
	      var selectedItemIndex = _props$model.selectedItemIndex;
	      var direction = _props$model.direction;
	      var lastKeyboardSelectedItemIndex = _props$model.lastKeyboardSelectedItemIndex;
	
	      var items = this.filteredItems();
	      var suggestedName = selectedItemIndex !== null && items[lastKeyboardSelectedItemIndex] ? items[lastKeyboardSelectedItemIndex].name : null;
	      var value = submit ? inputValue : suggestedName || inputValue;
	      var wrapperClasses = (0, _classNames2.default)((_cx = {}, _defineProperty(_cx, _component2.default.searchBar, true), _defineProperty(_cx, _component2.default.clientNotReady, this.props.staticRender), _cx));
	      var inputProps = {
	        type: 'text',
	        name: 'keywords',
	        placeholder: 'Search by brand',
	        value: value,
	        autoComplete: 'off',
	        className: _component2.default.inputSearch,
	        onChange: this.handleChange,
	        onKeyDown: this.handleKeyDown,
	        onClick: this.handleClickInput,
	        ref: 'inputSearch',
	        disabled: this.props.staticRender
	      };
	
	      var dropdownProps = {
	        items: items,
	        numVisibleItems: this.props.numVisibleItems || 4,
	        selectedItemIndex: selectedItemIndex,
	        direction: direction,
	        open: this.state.open,
	        dispatch: this.props.dispatch,
	        handleClickItem: this.handleClickItem
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: wrapperClasses },
	        _react2.default.createElement(
	          'form',
	          { className: _component2.default.formSearch, action: '/search', acceptCharset: 'UTF-8', method: 'get', ref: 'formSearch' },
	          _react2.default.createElement('input', { name: 'utf8', type: 'hidden', value: '✓' }),
	          _react2.default.createElement('input', inputProps),
	          _react2.default.createElement(
	            'button',
	            { type: 'submit', className: _component2.default.submitButton },
	            _react2.default.createElement(_MagnifyingGlassIcon2.default, null)
	          ),
	          _react2.default.createElement(_Dropdown2.default, dropdownProps)
	        )
	      );
	    }
	  }]);
	
	  return SearchBar;
	}(_react.Component);
	
	SearchBar.propTypes = {
	  items: _react.PropTypes.array.isRequired,
	  numVisibleItems: _react.PropTypes.number,
	  model: _react.PropTypes.object.isRequired,
	  dispatch: _react.PropTypes.func.isRequired,
	  onBrandSelect: _react.PropTypes.func.isRequired,
	  onKeyEnter: _react.PropTypes.func,
	  staticRender: _react.PropTypes.bool
	};
	
	exports.default = (0, _reactClickOutside2.default)(SearchBar);

/***/ },

/***/ 317:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var itemHeight = exports.itemHeight = 63;

/***/ },

/***/ 472:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _component = __webpack_require__(316);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _brandsSearchBar = __webpack_require__(606);
	
	var _brandsSearchBar2 = _interopRequireDefault(_brandsSearchBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BrandsSearchBar = function (_Component) {
	  _inherits(BrandsSearchBar, _Component);
	
	  function BrandsSearchBar() {
	    _classCallCheck(this, BrandsSearchBar);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(BrandsSearchBar).apply(this, arguments));
	  }
	
	  _createClass(BrandsSearchBar, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var searchBarModel = _props.searchBarModel;
	      var allBrands = _props.model.allBrands;
	      var dispatch = _props.dispatch;
	      var staticRender = _props.staticRender;
	      var onBrandSelect = _props.onBrandSelect;
	      var onKeyEnter = _props.onKeyEnter;
	      var inlineStyle = _props.inlineStyle;
	
	
	      var searchBarProps = {
	        items: allBrands,
	        numVisibleItems: 5,
	        model: searchBarModel,
	        dispatch: dispatch,
	        staticRender: staticRender,
	        onBrandSelect: onBrandSelect,
	        onKeyEnter: onKeyEnter,
	        inlineStyle: inlineStyle
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: _brandsSearchBar2.default.brandsSearchBar, style: inlineStyle },
	        _react2.default.createElement(_component2.default, searchBarProps)
	      );
	    }
	  }]);
	
	  return BrandsSearchBar;
	}(_react.Component);
	
	BrandsSearchBar.propTypes = {
	  model: _react.PropTypes.object.isRequired,
	  searchBarModel: _react.PropTypes.object.isRequired,
	  dispatch: _react.PropTypes.func.isRequired,
	  onBrandSelect: _react.PropTypes.func.isRequired,
	  onKeyEnter: _react.PropTypes.func,
	  staticRender: _react.PropTypes.bool,
	  inlineStyle: _react.PropTypes.object
	};
	
	exports.default = BrandsSearchBar;

/***/ },

/***/ 473:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(5);
	
	var _server = __webpack_require__(508);
	
	var _redux = __webpack_require__(45);
	
	var _reactRedux = __webpack_require__(34);
	
	var _reduxLoop = __webpack_require__(24);
	
	var _BrandsSearchBar = __webpack_require__(472);
	
	var _BrandsSearchBar2 = _interopRequireDefault(_BrandsSearchBar);
	
	var _SearchBar = __webpack_require__(559);
	
	var _SearchBar2 = _interopRequireDefault(_SearchBar);
	
	var _reducer = __webpack_require__(528);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onBrandSelect = function onBrandSelect(data) {
	  window.location = data.link;
	};
	
	var rootReducer = (0, _reduxLoop.combineReducers)({
	  model: _reducer.reducer,
	  searchBarModel: _SearchBar2.default.reducer
	});
	
	var createReduxStore = function createReduxStore() {
	  return (0, _redux.createStore)(rootReducer, undefined, (0, _redux.compose)((0, _reduxLoop.install)(), typeof window !== 'undefined' && window.devToolsExtension ? window.devToolsExtension() : function (x) {
	    return x;
	  }));
	};
	
	var createContainer = function createContainer() {
	  var connector = function connector(s) {
	    return {
	      model: s.model.toJS(),
	      searchBarModel: s.searchBarModel.toJS(),
	      onBrandSelect: onBrandSelect
	    };
	  };
	
	  return (0, _reactRedux.connect)(connector)(_BrandsSearchBar2.default);
	};
	
	var standalone = function standalone(element) {
	  var store = createReduxStore();
	  var Container = createContainer();
	
	  store.dispatch(_reducer.Actions.loadBrandsStart());
	
	  (0, _reactDom.render)(_react2.default.createElement(Container, { store: store }), element);
	};
	
	var renderStaticMarkup = function renderStaticMarkup() {
	  var store = createReduxStore();
	  var Container = createContainer();
	  return (0, _server.renderToStaticMarkup)(_react2.default.createElement(Container, { store: store, staticRender: true }));
	};
	
	exports.default = {
	  reducer: _reducer.reducer,
	  View: _BrandsSearchBar2.default,
	  standalone: standalone,
	  renderStaticMarkup: renderStaticMarkup,
	  Actions: _reducer.Actions,
	  rootReducer: rootReducer
	};

/***/ },

/***/ 508:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(679);


/***/ },

/***/ 528:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.reducer = exports.loadBrands = exports.Actions = exports.initialState = undefined;
	
	var _createReducer;
	
	var _reduxAct = __webpack_require__(26);
	
	var _reduxLoop = __webpack_require__(24);
	
	var _immutable = __webpack_require__(16);
	
	var _createActions = __webpack_require__(29);
	
	var _createActions2 = _interopRequireDefault(_createActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = exports.initialState = (0, _immutable.fromJS)({
	  allBrands: []
	});
	
	var Actions = exports.Actions = (0, _createActions2.default)('BrandsSearchBar', ['loadBrandsStart', 'loadBrandsSuccess']);
	
	var loadBrands = exports.loadBrands = function loadBrands() {
	  var loadPromise = new Promise(function (resolve) {
	    var interval = setInterval(function () {
	      var allBrands = window.Raise.data.homepage.searchBrands;
	      if (allBrands && Object.keys(allBrands).length !== 0) {
	        clearInterval(interval);
	        resolve(allBrands);
	      }
	    }, 500);
	  });
	  return loadPromise.then(function (brands) {
	    return Actions.loadBrandsSuccess(brands);
	  });
	};
	
	var reducer = exports.reducer = (0, _reduxAct.createReducer)((_createReducer = {}, _defineProperty(_createReducer, Actions.loadBrandsStart, function (state) {
	  return (0, _reduxLoop.loop)(state, _reduxLoop.Effects.promise(loadBrands));
	}), _defineProperty(_createReducer, Actions.loadBrandsSuccess, function (state, brands) {
	  return state.set('allBrands', brands);
	}), _createReducer), initialState);

/***/ },

/***/ 555:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _dropdown = __webpack_require__(613);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	var _constants = __webpack_require__(317);
	
	var _DropdownItem = __webpack_require__(556);
	
	var _DropdownItem2 = _interopRequireDefault(_DropdownItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Dropdown = function (_Component) {
	  _inherits(Dropdown, _Component);
	
	  function Dropdown() {
	    _classCallCheck(this, Dropdown);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Dropdown).apply(this, arguments));
	  }
	
	  _createClass(Dropdown, [{
	    key: 'createItems',
	    value: function createItems() {
	      var _props = this.props;
	      var selectedItemIndex = _props.selectedItemIndex;
	      var dispatch = _props.dispatch;
	      var handleClickItem = _props.handleClickItem;
	
	      return this.props.items.map(function (item, i) {
	        var dropdownItemProps = {
	          key: i,
	          item: item,
	          index: i,
	          selected: selectedItemIndex === i,
	          dispatch: dispatch,
	          handleClickItem: handleClickItem
	        };
	        return _react2.default.createElement(_DropdownItem2.default, dropdownItemProps);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _cx;
	
	      var dropdownItems = this.createItems();
	      var dropdownClasses = (0, _classnames2.default)((_cx = {}, _defineProperty(_cx, _dropdown2.default.itemList, true), _defineProperty(_cx, _dropdown2.default.silverBottom, this.props.items.length), _defineProperty(_cx, _dropdown2.default.hide, !this.props.open), _cx));
	      var dropdownStyle = {
	        maxHeight: _constants.itemHeight * this.props.numVisibleItems + 'px'
	      };
	      var dropdownProps = {
	        className: dropdownClasses,
	        style: dropdownStyle,
	        ref: 'dropdown'
	      };
	      return _react2.default.createElement(
	        'ul',
	        dropdownProps,
	        dropdownItems
	      );
	    }
	  }]);
	
	  return Dropdown;
	}(_react.Component);
	
	Dropdown.propTypes = {
	  items: _react.PropTypes.array.isRequired,
	  numVisibleItems: _react.PropTypes.number.isRequired,
	  direction: _react.PropTypes.number,
	  open: _react.PropTypes.bool.isRequired,
	  selectedItemIndex: _react.PropTypes.number,
	  dispatch: _react.PropTypes.func.isRequired,
	  handleClickItem: _react.PropTypes.func.isRequired
	};
	
	exports.default = Dropdown;

/***/ },

/***/ 556:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _dropdownItem = __webpack_require__(614);
	
	var _dropdownItem2 = _interopRequireDefault(_dropdownItem);
	
	var _constants = __webpack_require__(317);
	
	var _reducer = __webpack_require__(219);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DropdownItem = function (_Component) {
	  _inherits(DropdownItem, _Component);
	
	  function DropdownItem() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DropdownItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(DropdownItem)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      numMoves: 0
	    }, _this.handleMouseMove = function () {
	      var numMoves = _this.state.numMoves + 1;
	      if (numMoves === 2) {
	        _this.props.dispatch(_reducer.Actions.selectItemByIndex(_this.props.index));
	        _this.setState({ numMoves: 0 });
	      } else if (numMoves < 2 && !_this.props.selected) {
	        _this.setState({ numMoves: numMoves });
	      }
	    }, _this.handleClick = function () {
	      var _this$props = _this.props;
	      var handleClickItem = _this$props.handleClickItem;
	      var item = _this$props.item;
	
	      handleClickItem(item.name, item);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DropdownItem, [{
	    key: 'render',
	    value: function render() {
	      var _cx, _cx2;
	
	      var _props = this.props;
	      var item = _props.item;
	      var selected = _props.selected;
	
	      var itemClasses = (0, _classnames2.default)((_cx = {}, _defineProperty(_cx, _dropdownItem2.default.item, true), _defineProperty(_cx, _dropdownItem2.default.selected, !!selected), _cx));
	      var itemStyle = {
	        height: _constants.itemHeight + 'px'
	      };
	      var itemProps = {
	        className: itemClasses,
	        style: itemStyle,
	        onClick: this.handleClick,
	        onMouseEnter: this.handleMouseEnter,
	        onMouseMove: this.handleMouseMove
	      };
	
	      var discountClassName = (0, _classnames2.default)((_cx2 = {}, _defineProperty(_cx2, _dropdownItem2.default.discount, true), _defineProperty(_cx2, _dropdownItem2.default.soldOut, item.info === 'Out of stock'), _cx2));
	
	      return _react2.default.createElement(
	        'li',
	        itemProps,
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('img', { src: item.image_url }),
	          _react2.default.createElement(
	            'div',
	            { className: _dropdownItem2.default.itemInfo },
	            _react2.default.createElement(
	              'div',
	              { className: _dropdownItem2.default.name },
	              item.name
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: discountClassName },
	              item.info
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return DropdownItem;
	}(_react.Component);
	
	DropdownItem.propTypes = {
	  item: _react.PropTypes.object.isRequired,
	  index: _react.PropTypes.number.isRequired,
	  selected: _react.PropTypes.bool,
	  dispatch: _react.PropTypes.func.isRequired,
	  handleClickItem: _react.PropTypes.func.isRequired
	};
	
	exports.default = DropdownItem;

/***/ },

/***/ 557:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _magnifyingGlass = __webpack_require__(615);
	
	var _magnifyingGlass2 = _interopRequireDefault(_magnifyingGlass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MagnifyingGlassIcon = function MagnifyingGlassIcon() {
	  return _react2.default.createElement(
	    'svg',
	    { className: _magnifyingGlass2.default.icon, width: '27px', height: '27px', viewBox: '0 0 27 27' },
	    _react2.default.createElement(
	      'g',
	      { stroke: 'none', strokeWidth: '1', fill: 'none', transform: 'translate(-502.000000, -13.000000)' },
	      _react2.default.createElement(
	        'g',
	        { transform: 'translate(515.500000, 23.500000) scale(-1, 1) translate(-515.500000, -23.500000) translate(498.000000, 6.000000)' },
	        _react2.default.createElement('rect', { id: '48px-copy-63', x: '0', y: '0', width: '35', height: '35' }),
	        _react2.default.createElement('path', { d: 'M27.7163542,31.6575 L21.4477083,25.3895833 L22.47875,24.3578125 L28.7473958,30.6257292 L27.7163542,31.6575 L27.7163542,31.6575 Z M5.83333333,15.925 C5.83333333,11.904375 9.104375,8.63333333 13.125,8.63333333 C17.145625,8.63333333 20.4166667,11.904375 20.4166667,15.925 C20.4166667,19.945625 17.145625,23.2166667 13.125,23.2166667 C9.104375,23.2166667 5.83333333,19.945625 5.83333333,15.925 L5.83333333,15.925 Z M30.2939583,30.1102083 L22.9942708,22.81125 C22.7208333,22.5378125 22.2366667,22.5378125 21.9632292,22.81125 L21.5023958,23.2720833 L19.8005208,21.5694792 C21.091875,20.0440625 21.875,18.0753125 21.875,15.925 C21.875,11.1008333 17.9498958,7.175 13.125,7.175 C8.30010417,7.175 4.375,11.1008333 4.375,15.925 C4.375,20.7498958 8.30010417,24.675 13.125,24.675 C15.2753125,24.675 17.2440625,23.891875 18.7694792,22.6005208 L20.4720833,24.303125 L19.9011458,24.8740625 C19.6160417,25.1584375 19.6160417,25.62 19.9011458,25.9051042 L27.2008333,33.2040625 C27.3430208,33.34625 27.5296875,33.4177083 27.7163542,33.4177083 C27.9030208,33.4177083 28.0896875,33.34625 28.231875,33.2040625 L30.2939583,31.14125 C30.4303125,31.0048958 30.5076042,30.8196875 30.5076042,30.6257292 C30.5076042,30.4325 30.4303125,30.2472917 30.2939583,30.1102083 L30.2939583,30.1102083 Z', id: 'Fill-126', fill: '#FFFFFF' })
	      )
	    )
	  );
	};
	
	exports.default = MagnifyingGlassIcon;

/***/ },

/***/ 558:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _reselect = __webpack_require__(695);
	
	var filterItems = function filterItems(inputValue, allItems, numVisibleItems) {
	  if (inputValue.length !== 0) {
	    var _ret = function () {
	      var inputValueLower = inputValue.toLowerCase();
	      var items = allItems.filter(function (item) {
	        return item.name.toLowerCase().indexOf(inputValueLower) === 0;
	      });
	      return {
	        v: items.length > numVisibleItems ? items.slice(0, numVisibleItems) : items
	      };
	    }();
	
	    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	  }
	  return [];
	};
	
	var inputValue = function inputValue(_ref) {
	  var _ref2 = _slicedToArray(_ref, 1);
	
	  var s = _ref2[0];
	
	  return s.inputValue;
	};
	
	var allItems = function allItems(_ref3) {
	  var _ref4 = _slicedToArray(_ref3, 2);
	
	  var p = _ref4[1];
	
	  return p.model.allItems;
	};
	
	var numVisibleItems = function numVisibleItems(_ref5) {
	  var _ref6 = _slicedToArray(_ref5, 2);
	
	  var p = _ref6[1];
	
	  return p.numVisibleItems;
	};
	
	exports.default = (0, _reselect.createSelector)(inputValue, allItems, numVisibleItems, filterItems);

/***/ },

/***/ 559:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(5);
	
	var _redux = __webpack_require__(45);
	
	var _reactRedux = __webpack_require__(34);
	
	var _reduxLoop = __webpack_require__(24);
	
	var _component = __webpack_require__(316);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _reducer = __webpack_require__(219);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var standalone = function standalone(element) {
	  var store = (0, _redux.createStore)(_reducer.reducer, undefined, (0, _redux.compose)((0, _reduxLoop.install)(), typeof window !== 'undefined' && window.devToolsExtension ? window.devToolsExtension() : function (x) {
	    return x;
	  }));
	
	  var connector = function connector(s) {
	    return { model: s.toJS() };
	  };
	  var Container = (0, _reactRedux.connect)(connector)(_component2.default);
	
	  (0, _reactDom.render)(_react2.default.createElement(Container, { store: store }), element);
	};
	
	exports.default = {
	  reducer: _reducer.reducer,
	  View: _component2.default,
	  standalone: standalone,
	  Actions: _reducer.Actions
	};

/***/ },

/***/ 606:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"brandsSearchBar":"brandsSearchBar--1mBxG"};

/***/ },

/***/ 612:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"searchBar":"searchBar--1qj0L","formSearch":"formSearch--1pz4w","inputSearch":"inputSearch--31sQS","submitButton":"submitButton--2qKjF","clientNotReady":"clientNotReady--3zyko"};

/***/ },

/***/ 613:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"itemList":"itemList--2UHHE","silverBottom":"silverBottom--3_o4t","hide":"hide--2XfNj"};

/***/ },

/***/ 614:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"item":"item--1C8S2","itemInfo":"itemInfo--tDRsr","name":"name--2Iu3o","discount":"discount--E7kR_","soldOut":"soldOut--3TBvf","selected":"selected--12sBR"};

/***/ },

/***/ 615:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"icon":"icon--2ugJy"};

/***/ },

/***/ 695:
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.defaultMemoize = defaultMemoize;
	exports.createSelectorCreator = createSelectorCreator;
	exports.createSelector = createSelector;
	exports.createStructuredSelector = createStructuredSelector;
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function defaultEqualityCheck(a, b) {
	  return a === b;
	}
	
	function defaultMemoize(func) {
	  var equalityCheck = arguments.length <= 1 || arguments[1] === undefined ? defaultEqualityCheck : arguments[1];
	
	  var lastArgs = null;
	  var lastResult = null;
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    if (lastArgs !== null && lastArgs.length === args.length && args.every(function (value, index) {
	      return equalityCheck(value, lastArgs[index]);
	    })) {
	      return lastResult;
	    }
	    lastArgs = args;
	    lastResult = func.apply(undefined, args);
	    return lastResult;
	  };
	}
	
	function getDependencies(funcs) {
	  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
	
	  if (!dependencies.every(function (dep) {
	    return typeof dep === 'function';
	  })) {
	    var dependencyTypes = dependencies.map(function (dep) {
	      return typeof dep;
	    }).join(', ');
	    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
	  }
	
	  return dependencies;
	}
	
	function createSelectorCreator(memoize) {
	  for (var _len2 = arguments.length, memoizeOptions = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    memoizeOptions[_key2 - 1] = arguments[_key2];
	  }
	
	  return function () {
	    for (var _len3 = arguments.length, funcs = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      funcs[_key3] = arguments[_key3];
	    }
	
	    var recomputations = 0;
	    var resultFunc = funcs.pop();
	    var dependencies = getDependencies(funcs);
	
	    var memoizedResultFunc = memoize.apply(undefined, [function () {
	      recomputations++;
	      return resultFunc.apply(undefined, arguments);
	    }].concat(memoizeOptions));
	
	    var selector = function selector(state, props) {
	      for (var _len4 = arguments.length, args = Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
	        args[_key4 - 2] = arguments[_key4];
	      }
	
	      var params = dependencies.map(function (dependency) {
	        return dependency.apply(undefined, [state, props].concat(args));
	      });
	      return memoizedResultFunc.apply(undefined, _toConsumableArray(params));
	    };
	
	    selector.resultFunc = resultFunc;
	    selector.recomputations = function () {
	      return recomputations;
	    };
	    selector.resetRecomputations = function () {
	      return recomputations = 0;
	    };
	    return selector;
	  };
	}
	
	function createSelector() {
	  return createSelectorCreator(defaultMemoize).apply(undefined, arguments);
	}
	
	function createStructuredSelector(selectors) {
	  var selectorCreator = arguments.length <= 1 || arguments[1] === undefined ? createSelector : arguments[1];
	
	  if (typeof selectors !== 'object') {
	    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
	  }
	  var objectKeys = Object.keys(selectors);
	  return selectorCreator(objectKeys.map(function (key) {
	    return selectors[key];
	  }), function () {
	    for (var _len5 = arguments.length, values = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	      values[_key5] = arguments[_key5];
	    }
	
	    return values.reduce(function (composition, value, index) {
	      composition[objectKeys[index]] = value;
	      return composition;
	    }, {});
	  });
	}

/***/ },

/***/ 724:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getTransitionEvent = function getTransitionEvent() {
	  var el = document.createElement('element');
	  var transitions = {
	    transition: 'transitionend',
	    OTransition: 'oTransitionEnd',
	    MozTransition: 'transitionend',
	    WebkitTransition: 'webkitTransitionEnd'
	  };
	  var t = void 0;
	  for (t in transitions) {
	    if (el.style[t] !== undefined) {
	      return transitions[t];
	    }
	  }
	  return false;
	};
	
	var isSupported = exports.isSupported = !!getTransitionEvent();
	var event = exports.event = getTransitionEvent();
	
	exports.default = {
	  isSupported: isSupported,
	  event: event
	};

/***/ },

/***/ 726:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.reducer = exports.Api = exports.Actions = exports.initialState = undefined;
	
	var _createReducer;
	
	var _reduxLoop = __webpack_require__(24);
	
	var _createActions = __webpack_require__(29);
	
	var _createActions2 = _interopRequireDefault(_createActions);
	
	var _reduxAct = __webpack_require__(26);
	
	var _immutable = __webpack_require__(16);
	
	var _utils = __webpack_require__(727);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* global branch */
	
	
	var initialState = exports.initialState = (0, _immutable.fromJS)({
	  inputValue: '',
	  status: _utils.statuses.INITIAL
	});
	
	var Actions = exports.Actions = (0, _createActions2.default)('TextAppForm', ['sendSmsStart', 'sendSmsSuccess', 'sendSmsFailure', 'updateInputValue']);
	
	var Api = exports.Api = {
	  sendSms: function sendSms(phoneNumber) {
	    var sendPromise = new Promise(function (resolve, reject) {
	      branch.sendSMS(phoneNumber, { channel: 'Website', feature: 'Text-Me-The-App' }, { make_new_link: false }, function (error) {
	        if (error) reject(error);else resolve();
	      });
	    });
	
	    return sendPromise.then(function () {
	      return Actions.sendSmsSuccess();
	    }).catch(function () {
	      return Actions.sendSmsFailure();
	    });
	  }
	};
	
	var reducer = exports.reducer = (0, _reduxAct.createReducer)((_createReducer = {}, _defineProperty(_createReducer, Actions.updateInputValue, function (state, input) {
	  return state.set('inputValue', input);
	}), _defineProperty(_createReducer, Actions.sendSmsStart, function (state) {
	  var canSend = (0, _utils.validatePhoneNumber)(state.get('inputValue')) && state.get('status') !== _utils.statuses.SUCCESS;
	
	  if (!canSend) return state;
	
	  var cleanedInput = (0, _utils.cleanInput)(state.get('inputValue'));
	
	  return (0, _reduxLoop.loop)(state.set('status', _utils.statuses.SENDING), _reduxLoop.Effects.promise(Api.sendSms, cleanedInput));
	}), _defineProperty(_createReducer, Actions.sendSmsSuccess, function (state) {
	  return state.set('status', _utils.statuses.SUCCESS);
	}), _defineProperty(_createReducer, Actions.sendSmsFailure, function (state) {
	  return state.set('status', _utils.statuses.ERROR);
	}), _createReducer), initialState);

/***/ },

/***/ 727:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Covers the following cases:
	 * 1231231234
	 * 123-123-1234
	 * 123 123 1234
	 * 123 - 123 - 1234
	 * (123) 123-1234
	 */
	var validatePhoneNumber = exports.validatePhoneNumber = function validatePhoneNumber(input) {
	  var PHONE_NUMBER_REGEXP = /^\s*\(?\s*\d{3}\s*\)?\s*-?\s*\d{3}\s*-?\s*\d{4}\s*$/;
	  return input && input.length && PHONE_NUMBER_REGEXP.test(input);
	};
	
	var cleanInput = exports.cleanInput = function cleanInput(input) {
	  return input.replace(/[^\d]/g, '');
	};
	
	var statuses = exports.statuses = {
	  INITIAL: 'statuses.INITIAL',
	  SENDING: 'statuses.SENDING',
	  ERROR: 'statuses.ERROR',
	  SUCCESS: 'statuses.SUCCESS'
	};

/***/ },

/***/ 1034:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FadeCarouselSide = __webpack_require__(1151);
	
	var _FadeCarouselSide2 = _interopRequireDefault(_FadeCarouselSide);
	
	var _heroCarousel = __webpack_require__(1459);
	
	var _heroCarousel2 = _interopRequireDefault(_heroCarousel);
	
	var _buttons = __webpack_require__(176);
	
	var _buttons2 = _interopRequireDefault(_buttons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HeroCarousel = function (_Component) {
	  _inherits(HeroCarousel, _Component);
	
	  function HeroCarousel() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HeroCarousel);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(HeroCarousel)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      slideIndex: 0
	    }, _this.handleChange = function (index) {
	      _this.setState({
	        slideIndex: index
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(HeroCarousel, [{
	    key: 'render',
	    value: function render() {
	      var ctaUrl = '' + window.location.origin + this.props.slides[this.state.slideIndex].ctaUrl;
	      var extUrl = this.props.slides[this.state.slideIndex].extUrl;
	      var link = extUrl || ctaUrl;
	      var ctaCopy = this.props.slides[this.state.slideIndex].cta;
	
	      return _react2.default.createElement(
	        'div',
	        { className: _heroCarousel2.default.heroCarousel },
	        _react2.default.createElement(_FadeCarouselSide2.default, { autoPlay: 10000, slides: this.props.slides, onChange: this.handleChange })
	      );
	    }
	  }]);
	
	  return HeroCarousel;
	}(_react.Component);
	
	HeroCarousel.propTypes = {
	  slides: _react.PropTypes.array
	};
	
	exports.default = HeroCarousel;

/***/ },

/***/ 1149:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rightArrow = _react2.default.createElement("path", { d: "M24.3,21.5c0,0.5-0.2,1.1-0.6,1.5L4.3,42.3c-0.8,0.8-2.2,0.8-3,0s-0.8-2.2,0-3l17.8-17.8L1.3,3.7c-0.8-0.8-0.8-2.2,0-3 s2.2-0.8,3,0L23.6,20C24.1,20.4,24.3,21,24.3,21.5" });
	
	var leftArrow = _react2.default.createElement(
	  "g",
	  { transform: "rotate(180, 12.5, 21.5)" },
	  rightArrow
	);
	
	var Arrow = function Arrow(props) {
	  var arrowStyle = {};
	  if (props.verticalOffset) arrowStyle.marginTop = props.verticalOffset + "px";
	
	  var arrow = props.direction === 'left' ? leftArrow : rightArrow;
	  return _react2.default.createElement(
	    "svg",
	    { width: 25, height: 43, fill: "#FFFFFF", viewBox: "0 0 25 43", version: "1.1", xmlns: "http://www.w3.org/2000/svg", style: arrowStyle },
	    arrow
	  );
	};
	
	Arrow.propTypes = {
	  direction: _react.PropTypes.string.isRequired,
	  verticalOffset: _react.PropTypes.number
	};
	
	exports.default = Arrow;

/***/ },

/***/ 1150:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _slide = __webpack_require__(1484);
	
	var _slide2 = _interopRequireDefault(_slide);
	
	var _buttons = __webpack_require__(176);
	
	var _buttons2 = _interopRequireDefault(_buttons);
	
	var _cssTransition = __webpack_require__(724);
	
	var _cssTransition2 = _interopRequireDefault(_cssTransition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Slide = function (_Component) {
	  _inherits(Slide, _Component);
	
	  function Slide() {
	    _classCallCheck(this, Slide);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Slide).apply(this, arguments));
	  }
	
	  _createClass(Slide, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (_cssTransition2.default.isSupported && this.props.onTransitionEnd) {
	        this.bindTransitionEnd();
	      }
	    }
	  }, {
	    key: 'bindTransitionEnd',
	    value: function bindTransitionEnd() {
	      var _this2 = this;
	
	      this.refs.slide.addEventListener(_cssTransition2.default.event, function (e) {
	        if (e.target.className.indexOf(_slide2.default.active) > -1) {
	          _this2.props.onTransitionEnd(e);
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var classes = _slide2.default.slide;
	      if (this.props.isActive) {
	        classes += ' ' + _slide2.default.active;
	      }
	
	      var desktopStyle = { backgroundImage: 'url(' + this.props.desktopImg + ')' };
	      var mobileStyle = { backgroundImage: 'url(' + this.props.mobileImg + ')' };
	      var elementImgStyle = { backgroundImage: 'url(' + this.props.elementImg + ')' };
	
	      return _react2.default.createElement(
	        'div',
	        { className: classes, ref: 'slide' },
	        _react2.default.createElement('div', { className: _slide2.default['desktop-bg'], style: desktopStyle }),
	        _react2.default.createElement('div', { className: _slide2.default['mobile-bg'], style: mobileStyle }),
	        _react2.default.createElement(
	          'div',
	          { className: _slide2.default['content-container'] },
	          _react2.default.createElement(
	            'p',
	            { className: _slide2.default.title },
	            this.props.title
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: _slide2.default['second-title'] },
	            this.props.secondTitle
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: _slide2.default.subtitle },
	            this.props.subtitle
	          ),
	          _react2.default.createElement('div', { className: _slide2.default['element-image'], style: elementImgStyle }),
	          _react2.default.createElement(
	            'a',
	            {
	              className: _buttons2.default.baseButton + ' ' + _buttons2.default.clearWhite + ' ' + _slide2.default.heroButton,
	              href: this.props.url
	            },
	            this.props.ctaCopy
	          )
	        )
	      );
	    }
	  }]);
	
	  return Slide;
	}(_react.Component);
	
	Slide.propTypes = {
	  desktopImg: _react.PropTypes.string.isRequired,
	  mobileImg: _react.PropTypes.string.isRequired,
	  elementImg: _react.PropTypes.string.isRequired,
	  title: _react.PropTypes.string.isRequired,
	  secondTitle: _react.PropTypes.string.isRequired,
	  subtitle: _react.PropTypes.string.isRequired,
	  onTransitionEnd: _react.PropTypes.func.isRequired,
	  isActive: _react.PropTypes.bool.isRequired,
	  url: _react.PropTypes.string.isRequired,
	  ctaCopy: _react.PropTypes.string.isRequired
	};
	
	exports.default = Slide;

/***/ },

/***/ 1151:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Slide = __webpack_require__(1150);
	
	var _Slide2 = _interopRequireDefault(_Slide);
	
	var _Arrow = __webpack_require__(1149);
	
	var _Arrow2 = _interopRequireDefault(_Arrow);
	
	var _index = __webpack_require__(1485);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _cssTransition = __webpack_require__(724);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var nextIndex = function nextIndex(currIndex, length) {
	  if (currIndex < length - 1) {
	    return currIndex + 1;
	  } else if (currIndex === length - 1) {
	    return 0;
	  }
	  return -1;
	};
	
	var prevIndex = function prevIndex(currIndex, length) {
	  if (currIndex > 0) {
	    return currIndex - 1;
	  } else if (currIndex === 0) {
	    return length - 1;
	  }
	  return -1;
	};
	
	var FadeCarouselSide = function (_Component) {
	  _inherits(FadeCarouselSide, _Component);
	
	  function FadeCarouselSide() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FadeCarouselSide);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(FadeCarouselSide)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      currIndex: 0,
	      isAnimating: false,
	      delay: _this.props.autoPlay > 0 ? _this.props.autoPlay : 0
	    }, _this.clickNext = function () {
	      _this.timerRemaining = _this.state.delay;
	      _this.fadeTo(nextIndex(_this.state.currIndex, _this.props.slides.length), 1);
	    }, _this.clickPrev = function () {
	      _this.fadeTo(prevIndex(_this.state.currIndex, _this.props.slides.length), -1);
	    }, _this.fadeTo = function (index) {
	      if (_this.state.isAnimating && _cssTransition.isSupported) return;
	
	      _this.timerStarted = new Date().getTime();
	      _this.setState({
	        currIndex: index,
	        isAnimating: true
	      });
	      if (_this.props.onChange) _this.props.onChange(index);
	    }, _this.clickDot = function (e) {
	      if (e.target.className.indexOf(_index2.default.dot) < 0) {
	        return;
	      }
	      var index = parseInt(e.target.getAttribute('data-index'), 10);
	      _this.fadeTo(index);
	    }, _this.setTransitionEnd = function () {
	      _this.setState({
	        isAnimating: false
	      });
	    }, _this.startSlideshow = function (delay) {
	      if (delay > 0) {
	        _this.timer = setTimeout(function () {
	          _this.clickNext();
	          _this.startSlideshow(_this.state.delay);
	        }, delay);
	        _this.timerStarted = new Date().getTime();
	      }
	    }, _this.pauseSlideshow = function () {
	      clearTimeout(_this.timer);
	      var delay = _this.timerRemaining || _this.state.delay;
	      _this.timerRemaining = delay - (new Date().getTime() - _this.timerStarted);
	    }, _this.resumeSlideshow = function () {
	      _this.startSlideshow(_this.timerRemaining);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(FadeCarouselSide, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.startSlideshow(this.state.delay);
	    }
	  }, {
	    key: 'createSlides',
	    value: function createSlides(currIndex) {
	      var _this2 = this;
	
	      return this.props.slides.map(function (slide, i) {
	        var slideProps = {
	          key: i,
	          id: i,
	          isActive: i === currIndex,
	          desktopImg: slide.desktopImg,
	          mobileImg: slide.mobileImg,
	          elementImg: slide.elementImg,
	          title: slide.title,
	          secondTitle: slide.secondTitle,
	          subtitle: slide.subtitle,
	          onTransitionEnd: _this2.setTransitionEnd,
	          url: slide.ctaUrl || slide.extUrl,
	          ctaCopy: slide.cta
	        };
	
	        return _react2.default.createElement(_Slide2.default, slideProps);
	      });
	    }
	  }, {
	    key: 'createPagination',
	    value: function createPagination(currIndex) {
	      var dots = this.props.slides.map(function (slide, i) {
	        var isActive = currIndex === i ? _index2.default.active : '';
	        return _react2.default.createElement('div', { className: _index2.default.dot + ' ' + isActive, key: i, 'data-index': i });
	      });
	      return _react2.default.createElement(
	        'div',
	        { className: _index2.default.pagination, onClick: this.clickDot },
	        ' ',
	        dots,
	        ' '
	      );
	    }
	  }, {
	    key: 'renderSlides',
	    value: function renderSlides(slides) {
	      if (slides.length > 1) {
	        var arrowVerticalOffset = this.props.arrowsVerticalOffset || 0;
	        var arrowRight = _react2.default.createElement(
	          'div',
	          { className: _index2.default.hitBox + ' ' + _index2.default.right, onClick: this.clickNext },
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.arrowWrapper, ref: 'arrowWrapper' },
	            _react2.default.createElement(_Arrow2.default, { direction: 'right', verticalOffset: arrowVerticalOffset })
	          )
	        );
	        var arrowLeft = _react2.default.createElement(
	          'div',
	          { className: _index2.default.hitBox + ' ' + _index2.default.left, onClick: this.clickPrev },
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.arrowWrapper, ref: 'arrowWrapper' },
	            _react2.default.createElement(_Arrow2.default, { direction: 'left', verticalOffset: arrowVerticalOffset })
	          )
	        );
	        var pagination = this.createPagination(this.state.currIndex);
	        return _react2.default.createElement(
	          'div',
	          { className: _index2.default.slideStage, onMouseEnter: this.pauseSlideshow, onMouseLeave: this.resumeSlideshow },
	          pagination,
	          arrowRight,
	          arrowLeft,
	          slides
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: _index2.default.slideStage },
	        slides
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var slides = this.createSlides(this.state.currIndex);
	      return this.renderSlides(slides);
	    }
	  }]);
	
	  return FadeCarouselSide;
	}(_react.Component);
	
	FadeCarouselSide.propTypes = {
	  slides: _react.PropTypes.array.isRequired,
	  autoPlay: _react.PropTypes.number,
	  arrowsVerticalOffset: _react.PropTypes.number,
	  onChange: _react.PropTypes.func
	};
	
	exports.default = FadeCarouselSide;

/***/ },

/***/ 1169:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utils = __webpack_require__(727);
	
	var _reducer = __webpack_require__(726);
	
	var _styles = __webpack_require__(1491);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var getContainerClasses = function getContainerClasses(staticRender) {
	  var _cx;
	
	  return (0, _classnames2.default)((_cx = {
	    'row-fluid': true
	  }, _defineProperty(_cx, _styles2.default.textAppContainer, true), _defineProperty(_cx, _styles2.default.clientNotReady, staticRender), _cx));
	};
	
	var getPhoneNumberClass = function getPhoneNumberClass(inputValue, status, isValid) {
	  var _cx2;
	
	  return (0, _classnames2.default)((_cx2 = {}, _defineProperty(_cx2, _styles2.default.phoneNumberInitial, true), _defineProperty(_cx2, _styles2.default.phoneNumberError, !isValid && inputValue && status === _utils.statuses.INITIAL), _defineProperty(_cx2, _styles2.default.phoneNumberSuccess, isValid && inputValue && status === _utils.statuses.INITIAL), _cx2));
	};
	
	var getInputDisabled = function getInputDisabled(status) {
	  var staticRender = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	  return staticRender || status !== _utils.statuses.INITIAL;
	};
	
	var getButtonDisabled = function getButtonDisabled(inputValue, status, isValid) {
	  return !isValid || !inputValue || status !== _utils.statuses.INITIAL;
	};
	
	var onInputKeyUp = function onInputKeyUp(dispatch, isValid) {
	  return function (ev) {
	    // user hit enter
	    if (ev.which === 13 && isValid) {
	      dispatch(_reducer.Actions.sendSmsStart());
	      return;
	    }
	
	    dispatch(_reducer.Actions.updateInputValue(ev.target.value));
	  };
	};
	
	var onButtonClick = function onButtonClick(dispatch, isValid) {
	  return function () {
	    if (isValid) {
	      dispatch(_reducer.Actions.sendSmsStart());
	    }
	  };
	};
	
	var getButtonText = function getButtonText(status) {
	  switch (status) {
	    case _utils.statuses.SENDING:
	      return 'Sending...';
	    case _utils.statuses.ERROR:
	      return 'Text Failed';
	    case _utils.statuses.SUCCESS:
	      return 'Link Sent!';
	    case _utils.statuses.INITIAL:
	    default:
	      return 'Text Me';
	  }
	};
	
	var phoneIconSvg = _react2.default.createElement(
	  'svg',
	  { width: '12px', height: '19px', viewBox: '0 0 12 19' },
	  _react2.default.createElement(
	    'g',
	    { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
	    _react2.default.createElement(
	      'g',
	      { transform: 'translate(-122.000000, -2054.000000)', fill: '#9B9B9B' },
	      _react2.default.createElement(
	        'g',
	        { transform: 'translate(-71.000000, 1822.000000)' },
	        _react2.default.createElement(
	          'g',
	          { transform: 'translate(177.000000, 215.000000)' },
	          _react2.default.createElement('path', { d: 'M16.585933,35.3 C16.976555,35.6694118 17.4517703,35.8541176 18.0103349,35.8541176 L25.9956938,35.8541176 C26.52689,35.8541176 27.0008612,35.6694118 27.3914833,35.3 C27.7833493,34.9294118 27.9786603,34.4811765 27.9786603,33.9788235 L27.9786603,18.8741176 C27.9786603,18.3729412 27.7833493,17.9235294 27.3914833,17.5541176 C27.0008612,17.1847059 26.52689,17 25.9956938,17 L18.0103349,17 C17.4517703,17 16.976555,17.1847059 16.585933,17.5541176 C16.195311,17.9235294 16,18.3729412 16,18.8741176 L16,33.9788235 C16,34.4811765 16.195311,34.9294118 16.585933,35.3 L16.585933,35.3 Z M17.5077512,21.2517647 C17.5077512,21.1188235 17.5637321,21.0129412 17.6470813,20.9082353 C17.7590431,20.8282353 17.8710048,20.7752941 18.0103349,20.7752941 L25.9683254,20.7752941 C26.1076555,20.7752941 26.2196172,20.8282353 26.3315789,20.9082353 C26.4149282,21.0129412 26.4709091,21.1188235 26.4709091,21.2517647 L26.4709091,31.6023529 C26.4709091,31.7341176 26.4149282,31.84 26.3315789,31.9458824 C26.2196172,32.0247059 26.1076555,32.0776471 25.9683254,32.0776471 L18.0103349,32.0776471 C17.8710048,32.0776471 17.7590431,32.0247059 17.6470813,31.9458824 C17.5637321,31.84 17.5077512,31.7341176 17.5077512,31.6023529 L17.5077512,21.2517647 L17.5077512,21.2517647 Z M20.747177,18.8741176 L23.2314833,18.8741176 C23.3994258,18.8741176 23.4827751,18.9541176 23.4827751,19.1117647 C23.4827751,19.2705882 23.3994258,19.3494118 23.2314833,19.3494118 L20.747177,19.3494118 C20.5792344,19.3494118 20.4946411,19.2705882 20.4946411,19.1117647 C20.4946411,18.9541176 20.5792344,18.8741176 20.747177,18.8741176 L20.747177,18.8741176 Z M21.9750239,32.7905882 C22.3382775,32.7905882 22.6169378,32.8964706 22.8682297,33.1341176 C23.1195215,33.3717647 23.2314833,33.6352941 23.2314833,33.9529412 C23.2314833,34.2964706 23.1195215,34.56 22.8682297,34.7976471 C22.6169378,35.0352941 22.3382775,35.1411765 21.9750239,35.1411765 C21.6403828,35.1411765 21.3604785,35.0352941 21.1091866,34.7976471 C20.8578947,34.56 20.747177,34.2964706 20.747177,33.9529412 C20.747177,33.6352941 20.8578947,33.3717647 21.1091866,33.1341176 C21.3604785,32.8964706 21.6403828,32.7905882 21.9750239,32.7905882 L21.9750239,32.7905882 Z', id: 'Fill-159-Copy' })
	        )
	      )
	    )
	  )
	);
	
	exports.default = function (_ref) {
	  var _ref$model = _ref.model;
	  var inputValue = _ref$model.inputValue;
	  var status = _ref$model.status;
	  var dispatch = _ref.dispatch;
	  var staticRender = _ref.staticRender;
	
	  var isValid = (0, _utils.validatePhoneNumber)(inputValue);
	  return _react2.default.createElement(
	    'div',
	    { className: getContainerClasses(staticRender) },
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.inputContainer },
	      _react2.default.createElement(
	        'span',
	        { className: _styles2.default.phoneIcon },
	        phoneIconSvg
	      ),
	      _react2.default.createElement('input', { className: getPhoneNumberClass(inputValue, status, isValid),
	        type: 'text',
	        onKeyUp: onInputKeyUp(dispatch, isValid),
	        disabled: getInputDisabled(status, staticRender),
	        placeholder: '(###) ### - ####'
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.buttonContainer },
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-primary ' + _styles2.default.getLinkButton,
	          onClick: onButtonClick(dispatch, isValid),
	          disabled: getButtonDisabled(inputValue, status, isValid)
	        },
	        getButtonText(status)
	      )
	    )
	  );
	};

/***/ },

/***/ 1170:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(5);
	
	var _server = __webpack_require__(508);
	
	var _redux = __webpack_require__(45);
	
	var _reactRedux = __webpack_require__(34);
	
	var _reduxLoop = __webpack_require__(24);
	
	var _component = __webpack_require__(1169);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _reducer = __webpack_require__(726);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createReduxStore = function createReduxStore() {
	  return (0, _redux.createStore)(_reducer.reducer, undefined, (0, _redux.compose)((0, _reduxLoop.install)(), typeof window !== 'undefined' && window.devToolsExtension ? window.devToolsExtension() : function (x) {
	    return x;
	  }));
	};
	
	var createContainer = function createContainer() {
	  var connector = function connector(s) {
	    return { model: s.toJS() };
	  };
	  return (0, _reactRedux.connect)(connector)(_component2.default);
	};
	
	var standalone = function standalone(element) {
	  var store = createReduxStore();
	  var Container = createContainer();
	
	  (0, _reactDom.render)(_react2.default.createElement(Container, { store: store }), element);
	};
	
	var renderStaticMarkup = function renderStaticMarkup() {
	  var store = createReduxStore();
	  var Container = createContainer();
	  return (0, _server.renderToStaticMarkup)(_react2.default.createElement(Container, { store: store, staticRender: true }));
	};
	
	exports.default = {
	  reducer: _reducer.reducer,
	  Actions: _reducer.Actions,
	  View: _component2.default,
	  standalone: standalone,
	  renderStaticMarkup: renderStaticMarkup
	};

/***/ },

/***/ 1459:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"heroCarousel":"heroCarousel--3SQ-J","heroButton":"heroButton--3D0Nx","brandsSearchBar":"brandsSearchBar--10tc_"};

/***/ },

/***/ 1484:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"slide":"slide--16O7P","content-container":"content-container--3Fc1Z","title":"title--Y2IbV","second-title":"second-title--35mZH","subtitle":"subtitle--1I7Fz","element-image":"element-image--MsZ9V","active":"active--2ArdD","desktop-bg":"desktop-bg--X9jVI","mobile-bg":"mobile-bg--3mLt5","heroButton":"heroButton--hc9Ym","desktop-title-image":"desktop-title-image--2K_bN","mobile-title-image":"mobile-title-image--3Ymxs"};

/***/ },

/***/ 1485:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"slideStage":"slideStage--o-Zg4","hitBox":"hitBox--3LRWx","arrowWrapper":"arrowWrapper--1b670","right":"right--3co85","left":"left--ussJi","pagination":"pagination--39i5y","dot":"dot--3oHkC","active":"active--2el4G"};

/***/ },

/***/ 1491:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"textAppContainer":"textAppContainer--uHdI6","phoneNumberInitial":"phoneNumberInitial--2UKp-","phoneNumberError":"phoneNumberError--i7bie","phoneNumberSuccess":"phoneNumberSuccess--tmp-1","getLinkButton":"getLinkButton--2lsgU","buttonContainer":"buttonContainer--1G42-","inputContainer":"inputContainer--3_oUw","phoneIcon":"phoneIcon--2Bc8R","clientNotReady":"clientNotReady--7GeHX"};

/***/ }

});


/** WEBPACK FOOTER **
 ** webpack/javascripts/homepage-e8ad93496410515360ec.js
 **/